import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CardComponent } from '@bn/web-ui/card/card.component';

@Component({
  selector: 'app-shield-action-precedence-component',
  imports: [CardComponent, FaIconComponent],
  templateUrl: './app-shield-action-precedence-component.html',
  styleUrl: './app-shield-action-precedence-component.scss',
})
export class AppShieldActionPrecedenceComponent {}
